export enum Type {
  notification = 'notification',
  event = 'event',
}

export enum Notifications {
  actionInfo = 'actionInfo',
  personalOffer = 'personalOffer',
  interview = 'interview',
}

export enum Events {
  sms = 'sms',
  email = 'email',
}

export interface Props {
  type: Type;
  value: boolean;
  notification?: Notifications;
  event?: Events;
  disabled?: boolean;
}

export interface InnerProps {
  id: string;
  title: string;
  value: boolean;
  disabled?: boolean;
  onClick: () => void;
}
